import gql from "graphql-tag";

const ShortTermProps = gql`
    fragment ShortTermProps on ShortAssessment {
        id
        created_at
        presenting_problem
        family_history
        personal_history
        social_history
        mental {
            key
            value
        }
        medical_history
        physical_health_check
        smoking_status
        known_allergies
        special_dietary
        issue_with_Medicine
        patient_perception
        admission_tasks {
            item
            applicable
            comments
        }
        medication_prescribed {
            regular
            prn
        }
        past_psychiatric
        author {
            id
            surname
            first_name
            middle_name
            designation {
                id
                name
            }
        }
        confirm {
            status
        }
    }
`;

export const NEW_SHORT_ASSESSMENT = gql`
    mutation NEWShortAssessment($model: ShortAssessmentInput!, $confirm: Boolean!) {
        NewShortAssessment(model: $model, confirm: $confirm) {
            message
            doc {
                ...ShortTermProps
            }
        }
    }
    ${ShortTermProps}
`;

export const GET_SHORT_ASSESSMENT = gql`
    query getShortAssessment($patient: ID!, $page: Int, $limit: Int) {
        GetPatientShortAssessments(patient: $patient, page: $page, limit: $limit) {
            docs {
                ...ShortTermProps
            }
            page
            pages
            totalDocs
            totalPages
            limit
            prevPage
            nextPage
        }
    }
    ${ShortTermProps}
`;

export const CONFIRM_SHORT_ASSESSMENT = gql`
    mutation ConfirmShortAssessment($id: ID!) {
        ConfirmShortAssessment(id: $id) {
            message
            doc {
                ...ShortTermProps
            }
        }
    }
    ${ShortTermProps}
`;
